import { render, staticRenderFns } from "./LinhaDeContasAReceberResumo.vue?vue&type=template&id=47585648&scoped=true"
import script from "./LinhaDeContasAReceberResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeContasAReceberResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeContasAReceberResumo.vue?vue&type=style&index=0&id=47585648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47585648",
  null
  
)

export default component.exports